import { useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../language/keys';
import style from '../style';

type OverrideEligibilityDialogProps = {
  isOpen: boolean,
  isSubmitting: boolean,
  onConfirm: (reason: string) => void,
  onClose: () => void,
};

export const OverrideEligibilityDialog = ({
  isOpen,
  isSubmitting,
  onConfirm,
  onClose,
}: OverrideEligibilityDialogProps): JSX.Element => {
  const { t: translate } = useTranslation();
  const [reason, setReason] = useState('');
  const trimmedReason = reason.trim();

  return (
    <Dialog open={ isOpen } onClose={ onClose } fullWidth>
      <DialogTitle>{ translate(STRING_KEYS.REFERRALS.OVERRIDE_DIALOG_TITLE) }</DialogTitle>
      <DialogContent>
        <DialogContentText>{ translate(STRING_KEYS.REFERRALS.OVERRIDE_DIALOG_SUB_TITLE) }</DialogContentText>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={ 2 }
          label={ translate(STRING_KEYS.REFERRALS.OVERRIDE_DIALOG_REASON) }
          value={ reason }
          onChange={ (e) => setReason(e.target.value) }
          sx={ style.field.sx }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={ onClose }>{ translate(STRING_KEYS.DIALOG.BTN_GO_BACK) }</Button>
        <Button
          variant="contained"
          color="warning"
          disabled={ !trimmedReason || isSubmitting }
          onClick={ () => onConfirm(trimmedReason) }
        >
          { translate(STRING_KEYS.REFERRALS.OVERRIDE_DIALOG_BTN) }
        </Button>
      </DialogActions>
    </Dialog>
  );
};
